export default __webpack_public_path__ + "static/media/30.f0f18271.webp";